import Emitter from "./Emitter";
import {constants} from "../../constants";

export default class GameLoadStart extends Emitter {
    constructor(gb) {
        super(gb);
    }

    MGS_handler() {
        this.emitParent('{"Name" : "busy","Origin" : "embeddedgame"}');
    }

    SPINGAMES_handler() {
        this.emitTop({ event: "loading_start" });
        this.emitParent({ event: "loading_start" });
    }

    GAMEIOM_handler() {
        this.emitParent(JSON.stringify({wrapperAction:"gameLoadingStarted"}));
    }

    POKERSTARS_handler() {
        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify({"msgId":"rg2xcPreloaderStart"}), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify({"msgId":"rg2xcPreloaderStart"}), "*");
        }
    }

    PLAYTECH_handler() {
        let initData = {};

        if (this.gb.gameProviderCode && this.gb.gameProviderCode === 'GAM') {
            initData = {
                _type: "ucip.basic.g2wInitializationRequest",
                version: "1.0.0",
                features: ["pause", "closegame","loadingstatus","balanceupdate"]
            }
        } else {
            initData = {
                _type: "ucip.basic.g2wInitializationRequest",
                version: "1.0.0",
                features: ["autoplay", "pause", "closegame", "sound", "loadingstatus","gameround", "betupdate", "openpage"]
            }
        }

        if (this.gb.settings.nativeMobileApp) {
            initData.handled = true;
            window.parent.postMessage(JSON.stringify(initData));
        } else {
            this.emitParent(JSON.stringify(initData));
        }
    }

    SOFTSWISS_handler() {
        this.emitParent({type: "a8r:v1:gtp:game_load_started"});
    }

    _default() {
        this.emitTop({ wpgaction: "loadStart" });
        this.emitParent({ wpgaction: "loadStart.parent" });
        this.emitiOS({ wpgaction: "loadStart" });

        this.emitTop({ eventName: "loadProcessStart" });
        this.emitParent({ eventName: "loadProcessStart.parent" });
        this.emitiOS({ eventName: "loadProcessStart" });
    }
}
